import Loadable from 'react-loadable';
import Loading from '../system/views/loading.jsx';


const ModalMessage = Loadable({
	loader: () => import(/* webpackChunkName: "Modals" */ "./modals/modalmessage.jsx"),
	loading: Loading
});

const ModalDefault = Loadable({
	loader: () => import(/* webpackChunkName: "Modals" */ "./modals/modaldefault.jsx"),
	loading: Loading
});


let modals = {
	ModalMessage,
	ModalDefault
}

export default modals;